'use client';

import classNames from 'classnames';
import { useState } from 'react';

import { UploadcareImage } from '@/components/UploadcareImage';
import type { AccordionBlock, DataAttributes } from '@/types';
import { Intro } from '@/ui/Intro/Intro';
import { Container } from '@/ui/Section/Container/Container';
import { Section } from '@/ui/Section/Section';

import { Accordion } from './Accordion';

import styles from './PayloadAccordion.module.scss';

interface Props extends DataAttributes {
    block: AccordionBlock;
    className?: string;
}

export function PayloadAccordion({ block, className, ...attributes }: Props) {
    const { bgColor = 'white', items, has_intro: hasIntro, intro, reversed } = block;

    const [openedIndex, setOpenedIndex] = useState<number | undefined>(0);
    const secondaryContent = typeof openedIndex === 'number' ? items[openedIndex] : undefined;

    return (
        <Section
            data-payload-accordion={block.id}
            {...attributes}
            primary={bgColor}
            className={className}
        >
            <Container
                className={classNames(styles.container, {
                    [styles.reversed]: reversed,
                })}
            >
                <div>
                    {hasIntro && intro && (
                        <Intro
                            data-payload-accordion-intro
                            classes={{ byline: styles.byline }}
                            className={styles.intro}
                            {...intro}
                            hasBackground={bgColor !== 'white'}
                        />
                    )}
                    <Accordion
                        openedIndex={openedIndex}
                        setOpenedIndex={setOpenedIndex}
                        items={items}
                    />
                </div>
                <div className={styles.media} data-payload-accordion-media>
                    {secondaryContent && secondaryContent.image && (
                        <UploadcareImage
                            className={styles.image}
                            alt={secondaryContent.title}
                            height={800}
                            src={secondaryContent.image.url as string}
                            width={800}
                        />
                    )}
                </div>
            </Container>
        </Section>
    );
}
